import Type from "./type";

import Conf from "../common/config";
import Axios from './request'
const { MEDAL_LST } = Type;

/**
 * 列表
 * @param {*} args 
 */
export function lst(args) {
  return dispatch => {
    Axios.post(Conf.api + "/medal/lst", {
      ...args
    }).then(res => {
      if (!res.data.code) {
        dispatch({ type: MEDAL_LST, medalLst: res.data.data });
      }
    });
  };
}